import React, { ButtonHTMLAttributes } from 'react';
import cn from 'classnames';

import styles from './button.module.scss';

type ButtonSize = 'small' | 'default';

export enum ButtonStyleType {
  PRIMARY = 'button--primary',
  SECONDARY = 'button--secondary',
  WARNING = 'button--warning'
}

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: any;
  dataTestId?: string;
  buttonStyleType?: ButtonStyleType;
  buttonSize?: ButtonSize
}

export default function Button({
  children,
  type = 'button',
  dataTestId = 'button',
  buttonStyleType = ButtonStyleType.PRIMARY,
  className,
  buttonSize = 'default',
  ...restProps
}: IButtonProps) {
  const classNameString = cn(
    styles.button,
    styles[buttonStyleType],
    styles[`button--size-${buttonSize}`],
    className
  );

  return (
    <button
      className={classNameString}
      type={type}
      data-testid={dataTestId}
      {...restProps}
    >
      {children}
    </button>
  );
}
